<ng-container [ngTemplateOutlet]= "cardTemplateData ? dataView.doesNotExist ? DoesNotExist : CardContent : NoData"></ng-container>

<ng-template #CardContent>
  <div class="lm-card-view">

    <!-- Card has image -->
    <div *ngIf="cardTemplateData.imageUrl" class="{{cardTemplateData?.cardImageClasses}}">
      <img [src]="cardTemplateData.imageUrl" alt=""/>
    </div>

    <!-- Card does not have image and is using random avatars for missing image -->
    <div *ngIf="!cardTemplateData.imageUrl && cardTemplateData?.isMissingImage" class="{{cardTemplateData?.cardImageClasses}}">
      <span class="{{cardTemplateData?.bgColorClass}}">{{cardTemplateData?.imageForegroundText}}</span>
    </div>

    <div class="lm-card-content">
      <div #FlexContainer class="lm-card-flex">
        <ng-container *ngFor="let cols of cardTemplateData.columns; let x = index;">
          <ng-container>
            <div #CardColumn [ngClass]="{'lm-column': true}">
              <div *ngFor="let item of cols.column; let i = index;" class="lm-card-row" [ngClass]="{'lm-hyperlink-container': (item.isExternalNavigation || item.isInternalNavigation) && !(boldFirstRow && i === 0)}">
                <ng-container *ngIf="boldFirstRow && i === 0 && !item.isProcessIndicator; else NotFirstRow">
                  <!-- First field displays as a title -->
                  <!-- add lg font size class to first row of first column -->
                  <h3 [ngClass]="{'lm-blank-line': isBlankLine(item), 'lm-card-alert': isAlert(item), 'lm-font-lg': x === 0, 'lm-font-md': x > 0, 'lm-hyperlink-container': item.isExternalNavigation || item.isInternalNavigation}">
                    <span *ngIf="item.label && boldFirstRow && i === 0" lm-text-style [textStyle]="item?.textStyle">{{item.label}}:&nbsp;</span>
                    <ng-container [ngTemplateOutlet]="CardElementsTemplate"></ng-container>
                  </h3>
                </ng-container>

                <ng-template #NotFirstRow>
                  <ng-container [ngTemplateOutlet]="CardElementsTemplate"></ng-container>
                </ng-template>

                <ng-template #CardElementsTemplate>
                  <label *ngIf="item.label && i !== 0" lm-text-style [textStyle]="item?.textStyle">{{item.label}}:&nbsp;</label>
                  <ng-container *ngIf="!item.alertCondition">

                    <ng-container *ngIf="!item.displayAsTag && !item.displayAsRating">
                      <a *ngIf="item.isExternalNavigation" href="{{item?.httpUrl}}" class="hyperlink" [target]="item.openExternal ? '_blank' : ''" soho-tooltip [title]="item?.displayValue">{{item?.displayValue}}</a>
                      <a *ngIf="item.isInternalNavigation" href="javascript:void(0)" class="hyperlink" (click)="navigate(item)" soho-tooltip [title]="item?.displayValue">{{item?.displayValue}}</a>
                    </ng-container>

                    <!-- display as tag -->
                    <ng-container *ngIf="item.displayAsTag">

                      <span *ngIf="item.isField"
                            class="lm-card-field tag"
                            [style.color]="!!item?.fieldStyle?.color ? 'white' : null"
                            lm-field-style [fieldStyle]="item?.fieldStyle" [isTag]="true"
                      >{{item?.displayValue}}</span>

                      <a *ngIf="item.isExternalNavigation"
                         href="{{item?.httpUrl}}"
                         [target]="item.openExternal ? '_blank' : ''"

                         class="lm-card-field tag is-clickable"
                         [style.color]="!!item?.fieldStyle?.color ? 'white' : null"
                         lm-field-style [fieldStyle]="item?.fieldStyle" [isTag]="true"
                      >{{item?.displayValue}}<span>
                          <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                            <use xlink:href="#icon-caret-right"></use>
                          </svg>
                          <span class="audible"></span>
                        </span>
                      </a>

                      <a *ngIf="item.isInternalNavigation"
                         href="javascript:void(0)"
                         (click)="navigate(item)"

                         class="lm-card-field tag is-clickable"
                         [style.color]="!!item?.fieldStyle?.color ? 'white' : null"
                         lm-field-style [fieldStyle]="item?.fieldStyle" [isTag]="true"
                      >{{item?.displayValue.trim()}}<span>
                          <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                            <use xlink:href="#icon-caret-right"></use>
                          </svg>
                          <span class="audible"></span>
                        </span>
                      </a>
                    </ng-container>

                    <!-- display as rating -->
                    <ng-container *ngIf="item.displayAsRating">
                      <div soho-rating class="is-readonly" [style.padding-top]="'3px'">
                        <fieldset>
                          <!--        <legend class="audible">Rate Your Experience</legend>-->
                          <ng-container *ngFor="let option of item.ratingOptions; index as i">
                            <input
                                    type="radio"
                                    [ngClass]="option.class"
                                    name="rating_options"
                                    id="{{option.id}}"
                                    [attr.disabled]="true">
                            <label for="{{option.id}}">
                              <svg class="icon" focusable="false" aria-hidden="true" role="presentation">
                                <use [attr.xlink:href]="option.href"></use>
                              </svg>
                              <span class="audible">{{option.label}}</span>
                            </label>
                          </ng-container>
                        </fieldset>
                      </div>
                    </ng-container>

                    <!-- is field  -->
                    <span *ngIf="item.isField && !item.isFormText && !item.displayAsTag && !item.isRichText && !item.displayAsRating"
                          class="lm-card-field"
                          lm-field-style [fieldStyle]="item?.fieldStyle"
                    >{{item?.displayValue}}</span>

                    <!-- is form text-->
                    <span *ngIf="item.isFormText && !item.displayAsTag && !item.isRichText && !item.displayAsRating && !(item.isExternalNavigation || item.isInternalNavigation)"
                          class="lm-card-field"
                          lm-text-style [textStyle]="item?.textStyle"
                    >
                    <svg soho-icon *ngIf="item.icon && item.icon.sohoIcon" [icon]="item.icon.icon" class="icon" [attr.title]="item.displayValue" soho-tooltip [content]="item.displayValue" [placement]="'bottom'"></svg>
                    <img *ngIf="item.icon && !item.icon.sohoIcon" class="icon" src="{{item.icon.iconUrl}}">
                      {{item?.displayValue}}
                  </span>

                    <!-- is rich text-->
                    <span *ngIf="item.isField && !item.displayAsTag && !item.isFormText && item.isRichText && !item.displayAsRating"
                          class="lm-card-field"
                          lm-text-style [textStyle]="item?.textStyle"
                          [innerHTML]="item.displayValue | safe"
                    ></span>

                    <!-- process indicator -->
                    <div *ngIf="item.isProcessIndicator" class="process-indicator compact responsive has-labels">
                      <div class="display">
                        <div *ngFor="let data of item.processIndicatorDisplayData; index as i" class="step" id="step{{data.stepId}}">
                          <div class="lines">
                            <div class="indicator {{data.completionStatusInfo.indicatorClass}}" [ngClass]="{'icon': data.completionStatusInfo.iconInfo.icon}" soho-tooltip content="{{data | lmProcessIndicatorTooltip}}">
                              <svg *ngIf="data.completionStatusInfo.iconInfo.icon" soho-icon icon="{{data.completionStatusInfo.iconInfo.icon}}" class="{{data.completionStatusInfo.iconInfo.colorClass}}"></svg>
                            </div>
                            <span class="separator" [ngClass]="{'darker': (data.status === 'C' || data.status === 'X')}"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-container>

                  <!-- with alert -->
                  <label *ngIf="item.alertCondition"
                         [ngClass]="{'lm-card-alert': i !== 0, 'lm-font-md': true }"
                         lm-field-style [fieldStyle]="item?.fieldStyle"
                  >
                    <svg soho-icon [icon]="item.alertCondition.icon" [attr.class]="alertClass(item)" [attr.title]="item.alertCondition.alertTooltip" soho-tooltip [content]="item.alertCondition.alertTooltip" [placement]="'bottom'"></svg>
                    {{item?.displayValue}}
                  </label>

                  <!--<lm-simple-progress *ngIf="isProgress(item)" [lmProgressFieldData]="item.progressFieldData"></lm-simple-progress>-->
                  <lm-simple-progress *ngIf="item?.progressFieldData" [lmProgressFieldData]="item.progressFieldData" class="lm-font-md"></lm-simple-progress>
                </ng-template>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div *ngIf="cardTemplateData?.buttonRow?.length > 0" class="lm-card-button-row">
    <ng-container *ngFor="let b of cardTemplateData.buttonRow">
      <!-- icon only -->
      <ng-container *ngIf="b.isIconOnly; else NotIconButton">
        <button
                *ngIf="b.isIconOnly"
                soho-button="icon" [isToggle]="b?.isToggle" [isTogglePressed]="b.state?.isPressed" [icon]="b.icon"
                soho-tooltip [title]="b.displayTooltip ? b.actionReference?.label || b.actionReference?.tooltip : null"
                class="btn lm-icon-button"
                lm-field-style [fieldStyle]="b?.fieldStyle"
                [attr.data-action-reference]="stringifyJson(b?.actionReference)"
                [ngClass]="{'lm-missing-soho-icon': !b.icon}"
                (click)="onActionClicked($event)"
        >
          <span *ngIf="b.icon">{{b.actionReference?.label}}</span>
          <ng-container>
            <!-- Need nbsp, if span is empty then ids-enterprise css will hide it -->
            <span *ngIf="!b.icon" [ngStyle]="{'background-image': 'url(' + b.iconUrl + ')'}">&nbsp;</span>
            <span class="audible">{{b.actionReference?.label}}</span>
          </ng-container>
        </button>
      </ng-container>
      <ng-template #NotIconButton>
        <!-- httpUrl (external link)-->
        <a *ngIf="b.isOpenExternal"
           [ngClass]="{'btn hyperlink': b.isDisplayAsLink, 'btn': !b.isDisplayAsLink}"
           [attr.href]="b.httpUrl"
           target="_blank"
           (click)="external(b, $event)"
        >
          <span>{{b.actionReference?.label}}</span>
        </a>

        <!-- display buttons as links -->
        <button *ngIf="b.isDisplayAsLink && !b.isOpenExternal"
                class="btn hyperlink"
                lm-field-style [fieldStyle]="b?.fieldStyle"
                [attr.data-action-reference]="stringifyJson(b?.actionReference)"
                (click)="onActionClicked($event)"
        >
          <span>{{b.actionReference?.label}}</span>
        </button>

        <!-- action buttons -->
        <button *ngIf="!b.isDisplayAsLink && !b.isOpenExternal"
                class="btn"
                [ngClass]="{'lm-is-primary': b?.isPrimary}"
                lm-field-style [fieldStyle]="b?.fieldStyle"
                [attr.data-action-reference]="stringifyJson(b?.actionReference)"
                (click)="onActionClicked($event)"
        >
          <span>{{b.actionReference?.label}}</span>
        </button>
      </ng-template>
    </ng-container>
  </div>
</ng-template>

<ng-template #DoesNotExist>
  <del>
    <ng-container [ngTemplateOutlet]= "CardContent"></ng-container>
  </del>
</ng-template>

<ng-template #NoData>
  <p>{{noDataAvailable}}</p>
</ng-template>


